import React, { useState } from 'react';
import AnimatedPage from "../pages/AnimatedPage";
import GeneratedPost from "../subcomponents/GeneratedPost";
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState } from 'draft-js';
import { Button, Input, Label } from 'reactstrap';
import Swal from 'sweetalert2';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { useRecoilValue } from 'recoil';
import adFormDataAtom from '../atom/companydata';

export default function FaceD () {
  const [description, setDescription] = useState('');
  const [options, setOptions] = useState([]);
  const [response, setResponse] = useState("");

  const formData = useRecoilValue(adFormDataAtom);

  // You can now access the values from the atom
  console.log(formData.companyName);
  console.log(formData.companyDescription);
  console.log(formData.productName);
  console.log(formData.productDescription);

  const handleEditorChange = (content, editor) => {
      setResponse(editorState.getCurrentContent().getPlainText());
  };

  const handleResponseGeneration = () => {
    // Show loading box
    Swal.fire({
      title: 'Generating Response',
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });
  
    // Call API to generate response based on complaint and update response state
    fetch('https://tidy-healthy-armchair.glitch.me/social_media', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ prompt: "Generate for  facebook "+description + `and use this information if you can and if its not empty: company name:  ${formData.companyName}, company description:  ${formData.companyDescription}, product name:  ${formData.productName} and product description:  ${formData.productDescription}`})
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      setResponse(data.answer);
      // Close loading box
      Swal.close();
    })
    .catch(error => {
      console.error(error);
      // Close loading box and show error message
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something went wrong!',
      });
    });
  };

  const editorState = EditorState.createWithContent(ContentState.createFromText(response));

  return (
    <AnimatedPage>
    <div className="mx-auto max-w-lg">
      <h1 className="text-4xl text-center mb-4">Description</h1>
      <div className="flex flex-col mb-4">
        <label htmlFor="description" className="text-lg mb-2">Write a description of the Facebook posts you want</label>
        <textarea id="description" className="border p-2 h-24" value={description} onChange={(e) => setDescription(e.target.value)} />
      </div>
      <button className="bg-blue-500 text-white px-4 py-2 rounded" onClick={handleResponseGeneration}>Generate options</button>
      
      <div className="flex-1">
          <div className="mb-8">
            <Label htmlFor="response" className="text-gray-800 font-medium mb-2">Generated Response:</Label>
            <Editor
              id="response"
              editorState={editorState}
              initialValue={response}
              onEditorChange={handleEditorChange}
              apiKey={process.env.REACT_APP_API_KEY_TINY}
              toolbarClassName="border border-gray-400 rounded-md p-2"
              wrapperClassName="border border-gray-400 rounded-md mb-8"
              editorClassName="px-4 py-2"
            />
          </div>
        </div>
 


         
    </div>
    </AnimatedPage>
  );
}

